<template>
	<div class="pro-box">
  <div
    :class="{ 'has-mouse': hasMouse }"
    @touchstart="hasMouse = false"
  >
    <flipbook
      class="flipbook"
      :pages="pages"
      :pagesHiRes="pagesHiRes"
      :startPage="pageNum"
      v-slot="flipbook"
      ref="flipbook"
      @flip-left-start="onFlipLeftStart"
      @flip-left-end="onFlipLeftEnd"
      @flip-right-start="onFlipRightStart"
      @flip-right-end="onFlipRightEnd"
      @zoom-start="onZoomStart"
      @zoom-end="onZoomEnd"
    >
      <div class="action-bar">
        <left-icon
          class="btn left"
          :class="{ disabled: !flipbook.canFlipLeft }"
          @click="flipbook.flipLeft"
        />
        <plus-icon
          class="btn plus"
          :class="{ disabled: !flipbook.canZoomIn }"
          @click="flipbook.zoomIn"
        />
        <span class="page-num">
          Page {{ flipbook.page }} of {{ flipbook.numPages }}
        </span>
        <minus-icon
          class="btn minus"
          :class="{ disabled: !flipbook.canZoomOut }"
          @click="flipbook.zoomOut"
        />
        <right-icon
          class="btn right"
          :class="{ disabled: !flipbook.canFlipRight }"
          @click="flipbook.flipRight"
        />
      </div>
    </flipbook>
    
  </div>
  </div>
</template>

<script>
import 'vue-material-design-icons/styles.css'
import LeftIcon from 'vue-material-design-icons/ChevronLeftCircle'
import RightIcon from 'vue-material-design-icons/ChevronRightCircle'
import PlusIcon from 'vue-material-design-icons/PlusCircle'
import MinusIcon from 'vue-material-design-icons/MinusCircle'
import flipbook from 'flipbook-vue'
	import {
		articleDetail
	} from '@/api/reqFetch.js'
export default {
  components: { flipbook, LeftIcon, RightIcon, PlusIcon, MinusIcon },
  data() {
    return {
      pages: [],
      pagesHiRes: [],
      hasMouse: true,
      pageNum: null,
	  
    }
  },
  methods: {
    onFlipLeftStart(page) { console.log('flip-left-start', page) },
    onFlipLeftEnd(page) {
      console.log('flip-left-end', page)
      // window.location.hash = '#' + page
    },
    onFlipRightStart(page) { console.log('flip-right-start', page) },
    onFlipRightEnd(page) {
      console.log('flip-right-end', page)
      // window.location.hash = '#' + page
    },
    onZoomStart(zoom) {
      console.log('zoom-start', zoom)
    },
    onZoomEnd(zoom) {
      console.log('zoom-end', zoom)
    },
    setPageFromHash() {
      const n = parseInt(window.location.hash.slice(1), 10)
      if (isFinite(n)) this.pageNum = n
    },
	getNewDetail() {
		this.pages=[null]
		this.pagesHiRes=[null]
		articleDetail({
			id: this.id
		}).then(res => {
			if(res.data.fileList.length>0){
				res.data.fileList.map(item=>{
					this.pages.push(item.url)
					this.pagesHiRes.push(item.url)
				})
				
			}
		});
	},
  },
  mounted() {
    window.addEventListener('keydown', (ev) => {
      const flipbook = this.$refs.flipbook
      if (!flipbook) return
      if (ev.keyCode == 37 && flipbook.canFlipLeft) flipbook.flipLeft()
      if (ev.keyCode == 39 && flipbook.canFlipRight) flipbook.flipRight()
    })
	this.id = this.$route.query.id
	this.getNewDetail();

    // Simulate asynchronous pages initialization
    // setTimeout(() => {
    //   this.pages = [
    //     require('../../assets/img/1.png'),
    //     require('../../assets/img/2.png'),
    //     require('../../assets/img/3.png'),
    //     require('../../assets/img/4.png'),
    //     require('../../assets/img/5.png'),
    //     require('../../assets/img/6.png'),
    //   ]
    //   this.pagesHiRes = [
    //     require('../../assets/img/1.png'),
    //     require('../../assets/img/2.png'),
    //     require('../../assets/img/3.png'),
    //     require('../../assets/img/4.png'),
    //     require('../../assets/img/5.png'),
    //     require('../../assets/img/6.png'),
    //   ]
    // }, 1)

    window.addEventListener('hashchange', this.setPageFromHash)
    this.setPageFromHash()
  },
}
</script>

<style>


.pro-box {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  color: #ccc;
  overflow: hidden;
}


.action-bar {
  width: 100%;
  height: 30px;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-bar .btn {
  font-size: 30px;
  color: #999;
  display: inline-flex;
  position: relative;

}

@media (min-width: 1334px) {
  .action-bar .btn {
    padding-top: 25px;
    height: auto;
  }
}

@media (max-width: 767px) {
  .action-bar .btn {
    padding-top: 100px;
    height: auto;
  }
}

.action-bar .btn svg {
  bottom: 0;
}

.action-bar .btn:not(:first-child) {
  margin-left: 10px;
}

.has-mouse .action-bar .btn:hover {
  color: #ccc;
  filter: drop-shadow(1px 1px 5px #000);
  cursor: pointer;
}

.action-bar .btn:active {
  filter: none !important;
}

.action-bar .btn.disabled {
  color: #666;
  pointer-events: none;
}

.action-bar .page-num {
  font-size: 12px;
  margin-left: 10px;
}

.flipbook .viewport {
  width: 90vw !important;
  height: calc(100vh - 50px - 40px) !important;
}

.credit {
  font-size: 12px;
  line-height: 20px;
  margin: 10px;
}
</style>
